import React, {useCallback, useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {ListItem, Select, SelectValue} from '@phonectas/unifon-ui-kit';

interface LanguageSelectorProps {
	lang?: string;
	onChange: (value: string) => void;
	noAuto?: boolean;
	isDisabled?: boolean;
	compact?: boolean;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({
	lang = 'no',
	onChange,
	compact = false,
	noAuto = false,
	isDisabled = false
}) => {
	const [t] = useTranslation();
	const handleChange = useCallback((value: SelectValue) => {
		if (typeof value === 'string') {
			onChange(value);
		}
	}, [onChange]);

	const languageOptions = useMemo(() => {
		const options = [
			!noAuto ? {value: 'auto', label: 'Auto'} : null,
			{value: 'no', label: t('Norwegian')},
			{value: 'en', label: t('English')}
		].filter((option): option is { value: string; label: string } => option !== null);

		return options.map((option) => (
			<ListItem
				key={option.value}
				value={option.value}
				color="primary"
				selected={lang === option.value}
				primaryText={option.label}
			/>
		));
	}, [noAuto, lang, t]);

	return (
		<Select
			label={t('Language')}
			onChange={handleChange}
			value={lang}
			compact={compact}
			disabled={isDisabled}
		>
			{languageOptions}
		</Select>
	);
}

export default LanguageSelector;
